<div *ngIf="isLoading; else messageThread" class="d-flex align-items-center justify-content-center h-100">
  <app-loading-indicator></app-loading-indicator>
</div>
<ng-template #messageThread>
  <app-sendbird-message-thread
    [messageThread]="messageThreadDetails"
    [sendbirdMessage]="channelAndMessage?.messages"
    [sendbirdchannel]="channelAndMessage?.channel"
    [sendbirdparticiapant]="channelAndMessage?.channelInfo?.users"
    [isguestUserEnabled]="channelAndMessage?.channelInfo?.guestUserEnabled"
    [teamMembers]="teamMembers"
    [shipmentOrderPeople]="shipmentOrderPeople"
    [sendingMessage]="isSending"
    [payloadOfDialog]="this.data.payload"
    [defaultParticipantSectionFlag]="true"
    [sendBirdChannelInfo]="channelAndMessage?.channelInfo"
    (send)="onMessageSend($event)"
    (outSideClick)="onOutSideClick($event)"
    (S3fileMessageDownload)="downloadS3Message($event)"
  ></app-sendbird-message-thread>
</ng-template>
